import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { FiArrowRight, FiTrendingUp, FiShoppingCart, FiTarget, FiCode, FiTruck } from 'react-icons/fi';
import { useTranslation } from 'react-i18next';
import axios from 'axios';
import './Services.css';

const Services = () => {
  const { t, i18n } = useTranslation('common');
  const lang = i18n.language || 'en';
  const [services, setServices] = useState([]);

  useEffect(() => {
    const fetchServices = async () => {
      try {
        const res = await axios.get(`/api/services?lang=${lang}`);
        setServices(res.data.data || []);
      } catch (error) {
        console.error('Error fetching services:', error);
      }
    };
    fetchServices();
  }, [lang]);

  const icons = {
    'chart-line':    <FiTrendingUp />,
    'shopping-cart': <FiShoppingCart />,
    'bullhorn':      <FiTarget />,
    'code':          <FiCode />,
    'truck':         <FiTruck />
  };

  return (
    <div className="services-page">
      <section className="page-hero">
        <div className="container">
          <p className="page-label">{t('nav.menu.services.title')}</p>
          <h1>{t('home.services.title')}</h1>
          <p className="page-description">{t('home.services.description')}</p>
        </div>
      </section>

      <section className="section">
        <div className="container">
          <div className="services-list">
            {services.map((service, index) => (
              <div key={service._id || index} id={service.slug} className="service-detail">
                <div className="service-detail-icon">
                  {icons[service.icon] || <FiTrendingUp />}
                </div>
                <div className="service-detail-content">
                  <h2>{service.title}</h2>
                  <p>{service.description}</p>
                  <div className="service-detail-features">
                    {(service.features || []).map((feature, idx) => (
                      <span key={idx} className="feature-tag">{feature}</span>
                    ))}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="section section-dark">
        <div className="container text-center">
          <h2>{t('footer.cta.title')}</h2>
          <p style={{ maxWidth: '600px', margin: '0 auto 2rem' }}>
            {t('footer.cta.description')}
          </p>
          <Link to="/contact" className="btn btn-primary">
            {t('footer.cta.button')} <FiArrowRight />
          </Link>
        </div>
      </section>
    </div>
  );
};

export default Services;
